import { ISwAppMerchantTopUpAccountsApi } from "../../interfaces-and-types";

type TMerchantAccountUrls = {
  [key in keyof ISwAppMerchantTopUpAccountsApi]: string;
};

const rootUrl = "/merchant-dedicated-accounts";

export const merchantDedicatedTopUpAccountUrls: TMerchantAccountUrls = {
  createMerchantDedicatedTopUpAccount: `${rootUrl}/create`,
  getMerchantDedicatedTopUpAccounts: `${rootUrl}`,
  deallocateDedicatedTopUpAccountById: `${rootUrl}/deallocate/{id}`,
  revalidateDedicatedTopUpAccountById: `${rootUrl}/revalidate/{id}`,
  getPartnerBanks: `${rootUrl}/providers/banks`,
};
